// 工作台
export const CJ_LISTEN_YXHD_GZT = {
  key: 'CJ_LISTEN_YXHD_GZT',
  value: '工作台',
};
// 创建活动
export const CJ_LISTEN_YXHD_CJHD = {
  key: 'CJ_LISTEN_YXHD_CJHD',
  value: '创建活动',
};
// 会场运营
export const CJ_LISTEN_YXHD_HCYY = {
  key: 'CJ_LISTEN_YXHD_HCYY',
  value: '会场运营',
};
// 氛围打标
export const CJ_LISTEN_YXHD_FWDB = {
  key: 'CJ_LISTEN_YXHD_FWDB',
  value: '氛围打标',
};
// 活动选品
export const CJ_LISTEN_YXHD_HDXP = {
  key: 'CJ_LISTEN_YXHD_HDXP',
  value: '活动选品',
};
// 实时数据
export const CJ_LISTEN_YXHD_SSSJ = {
  key: 'CJ_LISTEN_YXHD_SSSJ',
  value: '实时数据',
};
// 活动对比
export const CJ_LISTEN_YXHD_HDDB = {
  key: 'CJ_LISTEN_YXHD_HDDB',
  value: '活动对比',
};
// 招商底池报名
export const CJ_LISTEN_YXHD_ZSDCBM = {
  key: 'CJ_LISTEN_YXHD_ZSDCBM',
  value: '招商底池报名',
};
// 活动盘货
export const CJ_LISTEN_YXHD_HDPH = {
  key: 'CJ_LISTEN_YXHD_HDPH',
  value: '活动盘货',
};
// 会场选品
export const CJ_LISTEN_YXHD_HCXP = {
  key: 'CJ_LISTEN_YXHD_HCXP',
  value: '会场选品',
};
// 页面搭建
export const CJ_LISTEN_YXHD_YMDJ = {
  key: 'CJ_LISTEN_YXHD_YMDJ',
  value: '页面搭建',
};
// 获取活动信息
export const CJ_LISTEN_YXHD_HQHDXX = {
  key: 'CJ_LISTEN_YXHD_HQHDXX',
  value: '获取活动信息',
};
// 会场活动报名
export const CJ_LISTEN_YXHD_HCHDBM = {
  key: 'CJ_LISTEN_YXHD_HCHDBM',
  value: '会场活动报名',
};
// 综促活动报名
export const CJ_LISTEN_YXHD_ZCHDBM = {
  key: 'CJ_LISTEN_YXHD_ZCHDBM',
  value: '综促活动报名',
};
// 分配活动资源
export const CJ_LISTEN_YXHD_FPHDZY = {
  key: 'CJ_LISTEN_YXHD_FPHDZY',
  value: '分配活动资源',
};
export const CJ_LISTEN_YXHD_BMGJJSH = {
  key: 'CJ_LISTEN_YXHD_BMGJJSH',
  value: '报名根据及审核',
};
//数据查看
export const CJ_LISTEN_YXHD_SJCK = {
  key: 'CJ_LISTEN_YXHD_SJCK',
  value: '数据查看',
};
//频道活动
export const CJ_LISTEN_YXHD_PDHD = {
  key: 'CJ_LISTEN_YXHD_PDHD',
  value: '频道活动',
};
// 活动报名
export const CJ_LISTEN_YXHD_QJHDBM = {
  key: 'CJ_LISTEN_YXHD_QJHDBM',
  value: '活动报名',
};

export const scene = {
  CJ_LISTEN_YXHD_GZT: '工作台',
  CJ_LISTEN_YXHD_CJHD: '创建活动',
  CJ_LISTEN_YXHD_HCYY: '会场运营',
  CJ_LISTEN_YXHD_FWDB: '氛围打标',
  CJ_LISTEN_YXHD_HDXP: '活动选品',
  CJ_LISTEN_YXHD_SSSJ: '实时数据',
  CJ_LISTEN_YXHD_HDDB: '活动对比',
  CJ_LISTEN_YXHD_HCHDBM: '会场活动报名',
  CJ_LISTEN_YXHD_ZCHDBM: '综促活动报名',
  CJ_LISTEN_YXHD_FPHDZY: '分配活动资源',
  CJ_LISTEN_YXHD_HQHDXX: '获取活动信息',
  CJ_LISTEN_YXHD_BMGJJSH: '报名根据及审核',
  CJ_LISTEN_YXHD_SJCK: '数据查看',
  CJ_LISTEN_YXHD_PDHD: '频道活动',
  CJ_LISTEN_YXHD_QJHDBM: '活动报名',
};
